import * as React from 'react'
import {
  AIDA_OVERLAY_OPEN_DURATION_MS,
  prefersReducedMotion,
} from '../../utils/overlay/overlay-animation'

export function useScrimFade(open: boolean) {
  const fadedRef = React.useRef(false)
  if (!open) {
    fadedRef.current = false
  }

  return React.useCallback((node: HTMLDivElement | null) => {
    if (!node || fadedRef.current || prefersReducedMotion() || typeof node.animate !== 'function') {
      return
    }
    fadedRef.current = true
    node.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: AIDA_OVERLAY_OPEN_DURATION_MS,
      easing: 'ease-out',
      fill: 'backwards',
    })
  }, [])
}
